var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#13C197",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5523 53.3856C73.9428 53.7761 73.9428 54.4093 73.5523 54.7998L59.0035 69.3486C58.6129 69.7392 57.9798 69.7392 57.5893 69.3486L52.2071 63.9665C51.8166 63.576 51.8166 62.9428 52.2071 62.5523L53.3856 61.3738C53.7761 60.9832 54.4093 60.9832 54.7998 61.3738L58.1196 64.6935C58.2172 64.7912 58.3755 64.7912 58.4731 64.6935L70.9596 52.2071C71.3501 51.8166 71.9832 51.8166 72.3738 52.2071L73.5523 53.3856Z",
    fill: "#13C197"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d208b039adc2164f926adf44a2edf97a.svg";
export { ForwardRef as ReactComponent };